<template>
	<div class="modal-card" style="min-width:500px;">
        <header class="modal-card-head">
            <p class="modal-card-title">Create Batch</p>
        </header>
        <section class="modal-card-body">
			<div class="field">
				<div class="field-body">
					<b-field label="Date">
						<b-datepicker
							icon="calendar"
							v-model="form.date"
			                trap-focus>
			            </b-datepicker>
			        </b-field>
				</div>
			</div>
			<div class="field">
				<div class="field-body">
					<b-field label="Notes">
						<b-input type="textarea" v-model="form.text"></b-input>
			        </b-field>
				</div>
			</div>
        </section>
        <footer class="modal-card-foot">
            <button class="button" style="position: absolute; left: 20px;" type="button" @click="$emit('update:createBatch', false)">Cancel</button>
            <button class="button is-info" type="button" @click="submit">Save</button>
        </footer>
    </div>
</template>
<script>
import { InvoiceService } from "@/services/invoice.service";
import moment from "moment";
export default {
	props: [ 'createBatch', 'selected' ],
    data: () => ({
    	form: {
    		text: null,
    		date: new Date(moment().toDate())
    	}
    }),
    methods: {
    	resetForm() {
    		this.form = {
    			text: null,
    			date: new Date(moment().toDate())
    		}
    	},
    	submit() {
    		InvoiceService.saveBatch(this.generateData()).then(response => {
      			this.$emit('refetch');
	    		this.resetForm()
	    		this.$emit('update:createBatch', false)
	    		this.$emit('update:selected', [])
				this.$buefy.toast.open({
					message: "New batch created",
					type: "is-success",
					position: "is-top-right"
				})
    		})
    	},
    	generateData() {
    		return {
    			date: this.form.date,
    			text: this.form.text,
    			selected: this.selected,
    		};
    	}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/invoices/batchModal.vue